import React from 'react'
import { BsFillRecordCircleFill } from 'react-icons/bs'

const TabHistory = () => {
    return (
        <div>
            <h1 className='font-bold text-3xl my-5 text-gray-700'>Our History</h1>
            <hr className="my-4" />

            <div className="">
                <div className="flex items-center space-x-5 my-5">
                    <BsFillRecordCircleFill className='text-primary-base' />
                    <h1 className="text-primary-dark-600 font-semibold text-lg">
                        {new Date().toDateString()}
                    </h1>
                </div>
                <div className="pl-7 border-l-2 ml-2 border-black">
                    <h2 className="my-4 text-lg font-semibold">Opening of Our First Store</h2>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ut culpa iusto soluta dolor ducimus eaque sapiente assumenda neque sequi, nesciunt ab alias architecto aliquid vero molestiae repellat magni aut labore?
                </div>
            </div>

            <div className="">
                <div className="flex items-center space-x-5 my-5">
                    <BsFillRecordCircleFill className='text-primary-base' />
                    <h1 className="text-primary-dark-600 font-semibold text-lg">
                        {new Date().toDateString()}
                    </h1>
                </div>
                <div className="pl-7 border-l-2 ml-2 border-black">
                    <h2 className="my-4 text-lg font-semibold">Opening of Our First Store</h2>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ut culpa iusto soluta dolor ducimus eaque sapiente assumenda neque sequi, nesciunt ab alias architecto aliquid vero molestiae repellat magni aut labore?
                </div>
            </div>

            <div className="">
                <div className="flex items-center space-x-5 my-5">
                    <BsFillRecordCircleFill className='text-primary-base' />
                    <h1 className="text-primary-dark-600 font-semibold text-lg">
                        {new Date().toDateString()}
                    </h1>
                </div>
                <div className="pl-7 border-l-2 ml-2 border-black">
                    <h2 className="my-4 text-lg font-semibold">Opening of Our First Store</h2>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ut culpa iusto soluta dolor ducimus eaque sapiente assumenda neque sequi, nesciunt ab alias architecto aliquid vero molestiae repellat magni aut labore?
                </div>
            </div>

            <div className="">
                <div className="flex items-center space-x-5 my-5">
                    <BsFillRecordCircleFill className='text-primary-base' />
                    <h1 className="text-primary-dark-600 font-semibold text-lg">
                        {new Date().toDateString()}
                    </h1>
                </div>
                <div className="pl-7 border-l-2 ml-2 border-black">
                    <h2 className="my-4 text-lg font-semibold">Opening of Our First Store</h2>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ut culpa iusto soluta dolor ducimus eaque sapiente assumenda neque sequi, nesciunt ab alias architecto aliquid vero molestiae repellat magni aut labore?
                </div>
            </div>

            <div className="">
                <div className="flex items-center space-x-5 my-5">
                    <BsFillRecordCircleFill className='text-primary-base' />
                    <h1 className="text-primary-dark-600 font-semibold text-lg">
                        {new Date().toDateString()}
                    </h1>
                </div>
                <div className="pl-7 border-l-2 ml-2 border-black">
                    <h2 className="my-4 text-lg font-semibold">Opening of Our First Store</h2>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ut culpa iusto soluta dolor ducimus eaque sapiente assumenda neque sequi, nesciunt ab alias architecto aliquid vero molestiae repellat magni aut labore?
                </div>
            </div>

            <div className="mb-8">
                <div className="flex items-center space-x-5 my-5">
                    <BsFillRecordCircleFill className='text-primary-base' />
                    <h1 className="text-primary-dark-600 font-semibold text-lg">
                        {new Date().toDateString()}
                    </h1>
                </div>
                <div className="pl-7 border-l-2 ml-2 border-black">
                    <h2 className="my-4 text-lg font-semibold">Opening of Our First Store</h2>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ut culpa iusto soluta dolor ducimus eaque sapiente assumenda neque sequi, nesciunt ab alias architecto aliquid vero molestiae repellat magni aut labore?
                </div>
            </div>

        </div>
    )
}

export default TabHistory